import Cookies from 'universal-cookie';
const cookies = new Cookies();

export const Login = (state, action) => {
    let login = true;
    let currentUser = state.currentUser 
    currentUser.name = JSON.parse(action.data).name
    currentUser.number = JSON.parse(action.data).number
    return Object.assign({}, state, { login, currentUser })
}

export const Logout = (state, action) => {
    cookies.remove('token', { path: '/' });
    cookies.remove('csrf', { path: '/' });
    cookies.remove('key', { path: '/' });
    let login = false
    return Object.assign({}, state, { login })
}


// WEBPACK FOOTER //
// ./src/Store/Reducers/LoginReducer.js